// @flow

import * as React from 'react';
import classnames from 'classnames';
import Link from 'components/Link';
import Badge from 'components/Badge';

import type { IconType } from 'components/Icon';

type Props = {|
    icon?: IconType,
    title: React.Node,
    url?: any,
    isStatic?: boolean,
    onClick?: (event: SyntheticMouseEvent<*>) => void,
    badge?: string | null
|};

const HeaderNavItem = ({
    icon,
    title = '',
    url,
    onClick,
    badge = null
}: Props): React.Node => (
    <li className={classnames('HeaderNavItem', { 'HeaderNavItem--no-icon': !icon })}>
        <Link icon={icon} to={url} onClick={onClick}>
            {title}
            {badge && <Badge content={badge} />}
        </Link>
    </li>
);

export default HeaderNavItem;
